import BaseModel from './BaseModel'
import {action, makeObservable, observable} from 'mobx'
import {post} from '../common/requester'

export default class Loc extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      company_id: observable,
      locations: observable,
      getLocations: action,
    })
  }
  
  company_id = 0
  locations = []
  
  async getLocations() {
    const res = await post('company/locations', {
      company_id: this.company_id
    }).catch((err) => console.error('--location error', err))
    if (res) {
      this.setProperty('locations', res.locations)
    }
  }
}